export default "__VITE_ASSET__CzQ9wza1__"